<div appAddDocumentationLink>
  @if (showSplashScreenComponent$ | async) {
    <app-splash-screen-page [attr.data-app]="'true'"></app-splash-screen-page>
  }
  <router-outlet></router-outlet>
  @if (!router.url.includes('auth') && themeConfig.isAnalyticsMode != true) {
    <app-public-chat-support></app-public-chat-support>
  }
  <app-x-information-bar></app-x-information-bar>
  <app-download-app-overlay></app-download-app-overlay>
  @if (environment.eventTrackingEnabled === true) {
    <app-cookie-banner />
  }
</div>
